



















import TenantMembership from '@/types/TenantMembership.interface'
import TenantMembershipLink from '@/components/TenantMembershipLink.vue'
import PersonShowTitle from '@/components/PersonShowTitle.vue'
import Vue from 'vue'
export default Vue.extend({
    components: { PersonShowTitle, TenantMembershipLink },
    computed: {
        active(): TenantMembership[] {
            //  If memberships so NOT exist, do nothing
            if (!this.memberships) return

            //  Else, filter out inactive (ie deleted) memberships
            const activeMemberships = this.memberships.filter((m: TenantMembership) => {
                return m.deleted_at === null
            })

            //  Return the active memberships
            return activeMemberships
        },
        memberships(): TenantMembership[] {
            return this.$store.getters.tenantMemberships
        },
        trashed(): TenantMembership[] {
            //  If memberships do NOT exist, do nothing
            if (!this.memberships) return

            //  Else, filter out active memberships
            const trashedMemberships = this.memberships.filter((m: TenantMembership) => {
                return m.deleted_at != null
            })

            //  Return the inactive (ie soft deleted) memberships
            return trashedMemberships
        }
    }
})
